export const MenuItems = {
    routePlanner: {
        id: 'routePlanner',
        text: 'MENU_ROUTE_PLANNER',
        path: 'route-planner',
        children: {
            planner: {
                id: 'planner',
                text: 'MENU_PLANNER',
                path: 'planner',
                children: {
                    employees: {
                        id: 'employees',
                        text: 'MENU_EMPLOYEES',
                        path: 'employees'
                    },
                    dataUpdate: {
                        id: 'dataUpdate',
                        text: 'MENU_DATA_UPDATE',
                        path: 'data-update'
                    },
                    optimization: {
                        id: 'optimization',
                        text: 'MENU_OPTIMIZATION',
                        path: 'optimization'
                    },
                    routePlanning: {
                        id: 'routePlanning',
                        text: 'MENU_ROUTE_PLANNING',
                        path: 'route-planning'
                    }
                }
            }
        }
    }
};
